export const initDataLayer = () => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'pageview',
    });
  } else {
    window.dataLayer = [
      {
        event: 'pageview',
      },
    ];
  }
};

export default function PublishEvent(event) {
  if (!window.dataLayer?.find(el => el['gtm.start'])) {
    initDataLayer();
  }
  window.dataLayer.push({
    ecommerce: null,
  });
  window.dataLayer.push(event);
}
